import { z } from 'zod';

import { BarcodeType } from '../types/barcode.type';

export const ORDER_SHIPMENT_BARCODE_CONTENT_SCHEMA = z
  .object({
    order_id: z.string(),
    shipment_id: z.string(),
  })
  .describe('ORDER_SHIPMENT_BARCODE_CONTENT_SCHEMA');

export const HTTP_BARCODE_RESPONSE_SCHEMA = z
  .discriminatedUnion('barcode_type', [
    z.object({
      barcode_content: ORDER_SHIPMENT_BARCODE_CONTENT_SCHEMA,
      barcode_type: z.literal(BarcodeType.OrderShipment),
    }),
  ])
  .describe('HTTP_BARCODE_RESPONSE_SCHEMA');
